export default{
    state(){
        return{
            data:[]
        }
    },
    getters:{
    },
    mutations: {
        authority(state,v){
            state.data = v
        }
    },
    actions: {
        authority(context,v){
            context.commit('authority',v)
        }
    },
}